// Job-list helpers shared by Dashboard and Profile: the list-item shape the
// backend returns, the status → badge mapping, and small formatters ported
// from careers.co.jp's jobFormat.

import type { ResumeJobStatus } from "@agp/shared";

export interface JobListItem {
  id: string;
  status: ResumeJobStatus;
  sourceFilename: string;
  sourceCount: number;
  candidateName: string | null;
  error: string | null;
  outputCount: number;
  ownerEmail: string;
  candidateOwner: string | null;
  createdAt: string;
}

export const STATUS_LABEL: Record<
  ResumeJobStatus,
  { label: string; variant: "neutral" | "accent" | "ok" | "warn" | "danger" }
> = {
  created: { label: "Uploading", variant: "neutral" },
  extracting: { label: "Extracting", variant: "accent" },
  ready_for_review: { label: "Ready for review", variant: "ok" },
  failed: { label: "Failed", variant: "danger" },
};

export function relativeTime(iso: string): string {
  const d = new Date(iso);
  const diff = Date.now() - d.getTime();
  if (diff < 60_000) return "just now";
  if (diff < 3_600_000) return `${Math.floor(diff / 60_000)}m ago`;
  if (diff < 86_400_000) return `${Math.floor(diff / 3_600_000)}h ago`;
  if (diff < 7 * 86_400_000) return `${Math.floor(diff / 86_400_000)}d ago`;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

/** "annick@agp.test" → "Annick" — the friendliest name the API gives us. */
export function displayNameFromEmail(email: string | null | undefined): string | null {
  const local = email?.split("@")[0];
  if (!local) return null;
  return local.charAt(0).toUpperCase() + local.slice(1);
}
